/**
 * Where a petty-cash / reimbursement `meta.errors` string should land on the submit form
 * (docs/PETTY_CASH_API.md and docs/REIMBURSEMENT_API.md, flow step 4). Both routes share the BFF,
 * so the "image must be at most 5 MB" multipart-cap message is mapped here for both.
 */
export type PettyCashErrorTarget = 'photoRequired' | 'photoTooLarge' | 'uploadFailed' | 'photo' | 'name' | 'amount' | 'wallet' | 'sameWallet' | 'inactive' | 'generic';

export function classifyPettyCashError(msg: string): PettyCashErrorTarget {
    if (msg === 'POS user is inactive or locked') return 'inactive';
    if (msg.startsWith('proof is required')) return 'photoRequired';
    if (msg.startsWith('proof must be at most') || msg.startsWith('image must be at most')) return 'photoTooLarge';
    if (msg.startsWith('proof upload failed')) return 'uploadFailed';
    if (msg.startsWith('proof')) return 'photo';
    if (msg.startsWith('name')) return 'name';
    if (msg.startsWith('amount')) return 'amount';
    if (msg.startsWith('Rwallet')) return 'wallet';
    if (msg.startsWith('source and destination')) return 'sameWallet';
    return 'generic';
}
